export default Object.freeze({
  TITLE: '회원이 존재하지 않습니다.',
  CLOSE: '닫기'
});
